module.exports = __webpack_public_path__ + "img/rla-mobile.bff16311.png";